import { Box, Button, Divider, Typography } from '@mui/material';
import { useContext, useState } from 'react';
import '../template.module.css';
import { ReportTemplatesContext } from '..';

export default function CreateTemplateSection() {
  const {
    setNewTemplateName,
    setCurrentStage,
    newTemplateName,
    lastStage,
    setLastStage,
    editing,
    getAccessToken,
  } = useContext(ReportTemplatesContext);
  const [error, setError] = useState(false);

  async function checkTemplateName(templateName) {
    try {
      const user = JSON.parse(localStorage.getItem('mongodbUser'));
      const url = `${process.env.REACT_APP_NODE_URL}/templates/check-name?templateName=${templateName}&userID=${user._id}`;
      const res = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${getAccessToken()}`,
        },
      });

      if (!res.ok) throw new Error('Error checking template name');

      const data = await res.json();
      return data.exists;
    } catch (error) {
      console.error('Error checking template name:', error);
      return false;
    }
  }

  async function handleContinue(e) {
    e.preventDefault();
    if (!newTemplateName) {
      setError(true);
      return;
    }

    if (!editing) {
      const nameCheck = await checkTemplateName(newTemplateName);
      if (nameCheck === true) {
        setError(true);
        alert('Template name already used. Please choose another.');
        return;
      }
    }

    if (lastStage === 'createTemplate') {
      setLastStage('customizeTemplate');
    }
    setCurrentStage('customizeTemplate');
  }

  return (
    <Box
      sx={{
        paddingX: '2rem',
        paddingY: '1.25rem',
        border: '1px solid #EDF2F7',
        borderRadius: '1rem',
      }}
    >
      <Typography
        sx={{
          fontFamily: 'Lato',
          fontSize: '1rem',
          fontWeight: 800,
          lineHeight: '24px',
          letterSpacing: '0.2px',
          textAlign: 'left',
          color: '#004852',
        }}
      >
        Name your Template
      </Typography>

      <input
        type='text'
        id='templateName'
        name='templateName'
        placeholder='Enter the name of your template'
        style={{
          width: '32rem',
          height: '2.75rem',
          marginTop: '1rem',
          padding: '0.5rem',
          border: error ? '1px solid #FF4747' : '1px solid #DFDFDF',
          borderRadius: '0.75rem',
        }}
        value={newTemplateName}
        onChange={e => {
          setError(false);
          setNewTemplateName(e.target.value);
        }}
      />

      <Divider sx={{ marginY: '1.25rem' }} />

      <Button
        variant='contained'
        sx={{
          width: 'auto',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '0.5rem',
          height: '3.5rem',
          backgroundColor: '#4FA490',
          color: '#FFFFFF',
          padding: '0.5rem 1.25rem 0.5rem 1.25rem',
          borderRadius: '0.75rem',
          '&:hover': {
            backgroundColor: '#4FA490',
          },
        }}
        onClick={handleContinue}
      >
        <Box
          sx={{
            height: '0.7rem',
            width: '0.7rem',
            borderRight: '2px solid #FFFFFF',
            borderBottom: '2px solid #FFFFFF',
            transform: 'rotate(-45deg)',
            marginRight: '0.5rem',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        ></Box>

        <Typography
          sx={{
            fontFamily: 'Lato',
            fontSize: '1rem',
            fontWeight: 700,
            lineHeight: '24px',
            letterSpacing: '0.2px',
            textAlign: 'center',
          }}
        >
          Continue
        </Typography>
      </Button>
    </Box>
  );
}
